var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#FED400",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 19.025c0-2.653-3.377-4.697-8-4.956V7.987C21 4.54 16.479 3 12 3S3.001 4.541 3 7.987V22.68c0 3.444 4.52 4.987 9 4.987.463 0 .933-.043 1.41-.09A14.057 14.057 0 0 0 20 29c4.479 0 9-1.543 9-4.987V19.025zm-2 0c0 1.411-2.993 2.988-7 2.988s-7-1.577-7-2.988a2.081 2.081 0 0 1 1.117-1.532.717.717 0 0 0 .066-.046A11.158 11.158 0 0 1 20 16.04c4.007 0 7 1.577 7 2.988v-.003zm-8-6.321a2.01 2.01 0 0 1-1.03 1.455 11.705 11.705 0 0 0-4.66 1.466c-.425.036-.855.063-1.31.063-3.77 0-7-1.643-7-2.987v-1.397a13.36 13.36 0 0 0 7 1.67 13.36 13.36 0 0 0 7-1.67v1.4zM5 15.799a12.819 12.819 0 0 0 6.319 1.876c-.206.42-.315.882-.319 1.35v1.611c-3.323-.255-6-1.72-6-2.944v-1.893zM12 5c3.441 0 7 1.117 7 2.988 0 1.94-3.6 2.987-7 2.987S5 9.928 5 7.988C5 6.118 8.559 5 12 5zM5 22.68v-1.895a12.646 12.646 0 0 0 6 1.856v1.372a3.497 3.497 0 0 0 .4 1.642C8.159 25.533 5 24.44 5 22.68zM20 27a12.134 12.134 0 0 1-5.705-1.23A2.17 2.17 0 0 1 13 24.014v-1.778A12.751 12.751 0 0 0 20 24.016a12.75 12.75 0 0 0 7-1.781v1.778C27 25.883 23.441 27 20 27z",
    fill: "#E3D380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.288cf83f7de9d184e73d387306fc5ea2.svg";
export { ForwardRef as ReactComponent };